<script>
import options from './StafetDeltagSomFighterFlow.options'
export default options
</script>

<template>
  <article class="kb-stafet-deltag-som-fighter-flow">
    <StafetHeader
      :steps="headerSteps"
      :title="labels.title"
      :description="labels.description"
    />

    <div class="kb-stafet-donation-flow__step">
      <component
        :is="currentStepName"
        :labels="labels"
        :nextStepCallback="nextStepCallback"
        :previousStepCallback="previousStepCallback"
        :displayInputError="displayInputError"
        :submitCallback="submitCallback"
        :updateBasketCallback="updateBasketCallback"
        :stafetId="stafetId"
        :tshirtSizes="tshirtSizes"
        :loggedIn="loggedIn"
        :redirectToEditProfile="redirectToEditProfile"
        :editProfileLinkText="editProfileLinkText"
        :holdList="holdList"
        :userData="userData"
        :isSubmitting="isSubmitting"
      />
    </div>
  </article>
</template>
